import SolarIcon from 'components/icons/SolarIcon';
import { LeadSelected } from 'modules/lead';
import { ObjectSelected } from 'modules/objects';
import type { TaskFilterModel } from '../model/useTaskFilter';
import { TASK_FILTER_LEAD_STATUSES, TASK_FILTER_OBJECT_STATUSES } from '../model/types';
import TaskFilterPicker from './TaskFilterPicker';
import TaskFilterSwitch from './TaskFilterSwitch';

interface TaskFilterRelatedProps {
    filter: TaskFilterModel;
}

const TaskFilterRelated = ({ filter }: TaskFilterRelatedProps) => {
    const {
        t,
        canFilterRelated,
        canPickRelated,
        canShowOnlyMine,
        draftLead,
        draftObject,
        draftOnlyPersonal,
        draftOnlyMine,
        draftOnlyMineLocked,
        draftLeadPickerOpen,
        draftObjectPickerOpen,
        setDraftOnlyMine,
        setDraftLeadPickerOpen,
        setDraftObjectPickerOpen,
        handleChangeLead,
        handleChangeObject,
        handleChangeOnlyPersonal,
    } = filter;

    return (
        <>
            {canPickRelated && !draftOnlyPersonal ? (
                <>
                    {!draftObject && !draftObjectPickerOpen ? (
                        <TaskFilterPicker
                            open={draftLeadPickerOpen}
                            hasValue={Boolean(draftLead)}
                            icon="person-lines-fill"
                            pickLabel={t('filterPickLead')}
                            cancelLabel={t('filterCancelPick')}
                            onOpen={() => setDraftLeadPickerOpen(true)}
                            onCancel={() => setDraftLeadPickerOpen(false)}
                        >
                            {(cancelButton) => (
                                <LeadSelected
                                    value={draftLead}
                                    onChange={handleChangeLead}
                                    title={t('labelLead')}
                                    maxHeight={180}
                                    className="mb-0"
                                    statuses={TASK_FILTER_LEAD_STATUSES}
                                    rightElement={cancelButton}
                                />
                            )}
                        </TaskFilterPicker>
                    ) : null}

                    {!draftLead && !draftLeadPickerOpen ? (
                        <TaskFilterPicker
                            open={draftObjectPickerOpen}
                            hasValue={Boolean(draftObject)}
                            icon="building"
                            pickLabel={t('filterPickObject')}
                            cancelLabel={t('filterCancelPick')}
                            onOpen={() => setDraftObjectPickerOpen(true)}
                            onCancel={() => setDraftObjectPickerOpen(false)}
                        >
                            {(cancelButton) => (
                                <ObjectSelected
                                    value={draftObject}
                                    onChange={handleChangeObject}
                                    title={t('labelObject')}
                                    maxHeight={180}
                                    className="mb-0"
                                    statuses={TASK_FILTER_OBJECT_STATUSES}
                                    rightElement={cancelButton}
                                />
                            )}
                        </TaskFilterPicker>
                    ) : null}
                </>
            ) : null}

            {canFilterRelated ? (
                <TaskFilterSwitch
                    id="task-filter-only-personal"
                    checked={draftOnlyPersonal}
                    label={t('filterOnlyPersonal')}
                    hint={t('filterOnlyPersonalHint')}
                    onChange={handleChangeOnlyPersonal}
                />
            ) : null}

            {canShowOnlyMine ? (
                <TaskFilterSwitch
                    id="task-filter-only-mine"
                    checked={draftOnlyMine && !draftOnlyMineLocked}
                    disabled={draftOnlyMineLocked}
                    className={`form-check form-switch mb-0${draftOnlyMineLocked ? ' opacity-50' : ''}`}
                    label={t('filterOnlyMine')}
                    hint={t('filterOnlyMineHint')}
                    onChange={setDraftOnlyMine}
                />
            ) : null}
        </>
    );
};

export default TaskFilterRelated;
